import styled from "styled-components";


export const Img = styled.img`
    width: 100%;
    display: block;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    display: block;
`;


export const ContainerMasonic = styled.div`
    /* min-height: 100vh; */
    height: calc(100vh - 121px);
    overflow: auto;
    width: 100%;
`;

export const TextCard = styled.div`
    display: flex;
    width: 100%;
    padding: 8px 10px;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: #FFFFFF;
    background: #C32105;

    

`;

export const Card = styled.div`
    display: flex;
    flex-direction: column;
    
    border-radius: solid;
    justify-content: center;
    align-items: center;
    border-radius: 10px 10px 0px 0px;
    transition: transform 100ms ease-in-out;
    
    max-width: 220px !important;
    margin-top: 20px !important;

    position: relative;

    .upItem {
        font-size: 13px;
        font-weight: bold;
        border-radius: 10px 10px 0px 0px;
        background: rgba(195, 34, 5, 0.452); 
        color: #FFFFFF;

        position: absolute;
        top: 0;
    }

    img {
        object-fit: cover;
        border-radius: 10px 10px 0px 0px;
    }

    &:hover {
      position: relative;
      transform: scale(1.125);
      z-index: 1000;
      box-shadow: 20px;
    }
`;

export const ModalContainer = styled.div`
    padding: 30px;
    display:flex;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #FFFFFF;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 20px ;


    .name {
        margin-top: 10px;
        font-size: 30px;
        color: #C32105;
        font-weight: bold;
    }
    .store {
        font-weight: bold;
    }
    .simple {
        font-size: 15px;
    }
`;